import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_printer_event.js";
//#region src/bite_log_printer_event_helper.ts
var bite_log_printer_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "connect-err";
		case 2: return "connect-timeout";
		case 3: return "disconnected";
		case 4: return "power-off";
		case 5: return "add-commands-err";
		case 6: return "send-err";
		case 7: return "print-job-fail";
		case 8: return "print-job-timeout";
		case 9: return "cover-open";
		case 10: return "paper-low";
		case 11: return "paper-empty";
		case 25: return "paper-ok";
		case 14: return "discovery-start-err";
		case 15: return "cover-closed";
		case 16: return "scanner-connect-err";
		case 17: return "scanner-disconnected";
		case 18: return "scale-connect-err";
		case 19: return "scale-disconnected";
		case 20: return "queue-enter-fail";
		case 21: return "queue-check-fail";
		case 22: return "queueing-disabled";
		case 23: return "print-job-requested";
		case 24: return "print-job-succeed";
		case 26: return "cutter-err";
		case 27: return "mechanical-err";
		case 28: return "auto-recover-err";
		case 29: return "unrecoverable-err";
		case 30: return "recoverable-err";
	}
}
//#endregion
export { bite_log_printer_event_helper_exports, name };

//# sourceMappingURL=bite_log_printer_event_helper.js.map